import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation('common');

  return (
    <section id="contact" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            {t('contact.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4 sm:mb-6">
              <i className="ri-phone-line text-2xl sm:text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{t('contact.phone')}</h3>
            <a href="tel:+237654391120" className="text-base sm:text-lg text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
              +237 654 391 120
            </a>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 sm:mb-6">
              <i className="ri-whatsapp-line text-2xl sm:text-3xl text-green-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{t('contact.whatsapp')}</h3>
            <a href="https://wa.me/237654391120" target="_blank" rel="noopener noreferrer" className="text-base sm:text-lg text-green-600 hover:text-green-700 font-medium cursor-pointer">
              +237 654 391 120
            </a>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 text-center hover:shadow-xl transition-shadow md:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4 sm:mb-6">
              <i className="ri-map-pin-line text-2xl sm:text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{t('contact.address')}</h3>
            <p className="text-base sm:text-lg text-gray-600">
              {t('contact.addressValue')}
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 md:mt-16 bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">{t('contact.hours')}</h3>
          <div className="max-w-md mx-auto space-y-3 sm:space-y-4">
            <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-200">
              <span className="text-sm sm:text-base font-semibold text-gray-700">{t('contact.everyday')}</span>
            </div>
            <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-200">
              <span className="text-sm sm:text-base text-gray-700">{t('contact.freshFishHours')}</span>
              <i className="ri-fish-line text-teal-600 text-lg"></i>
            </div>
            <div className="flex justify-between items-center py-2 sm:py-3">
              <span className="text-sm sm:text-base text-gray-700">{t('contact.grilledDeliveryHours')}</span>
              <i className="ri-fire-line text-orange-600 text-lg"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
